import { Language, useTranslations } from "@/lib";
import { SuccessIcon } from "../ui/icons";
export function Success({ lang }: { lang: Language }) {
  const { t } = useTranslations(lang);
  return (
    <>
      <div className="tw:flex tw:flex-col tw:items-center tw:justify-center tw:w-full tw:h-screen hide-footer--btn hide-header-btn">
        <div className="tw:font-semibold tw:px-4 tw:text-center tw:text-xl">
          <SuccessIcon className="tw:h-10 tw:w-10 tw:mx-auto tw:mb-5" />
          {t("success.title")}
          <div className="tw:md:mx-16 tw:text-base tw:font-medium tw:mt-1">
            {t("success.description")}
          </div>
        </div>
      </div>
    </>
  );
}
